import React from 'react';

import { useStyles } from 'features/app/components/Paper/styles';

interface PaperProps {
  className?: string;
  borderRadius?: number;
}

export const Paper: React.FC<PaperProps> = ({ className = '', borderRadius = 15, children }) => {
  const classes = useStyles({ borderRadius });

  return <div className={`${classes.paper} ${className}`}>{children}</div>;
};
